import { createContext, useContext } from 'react';
import { Country } from '@common/logic/services/country-service';

export const CountryCodeContext = createContext<Country | null>(null);

export function useCountryCode() {
  const country = useContext(CountryCodeContext);
  if (!country) {
    throw new Error('CountryContext not found');
  }

  return country;
}
